import { Component, Input } from '@angular/core';
import { OmpHeadingSize } from '../../../_models';
import {
  OmpCrossSellWideContentWidth,
  OmpCrossSellMaxColumns,
  OmpCrossSellNarrowMaxColumns,
  OmpPillButtonStyleOptions,
} from '../../order-management-portal.sections';
import { OmpSectionSettings } from '..';

@Component({
  selector: 'omp-cross-sell-carousel-settings',
  templateUrl: './cross-sell-carousel-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpCrossSellCarouselSettingsComponent extends OmpSectionSettings {
  public headingSize = OmpHeadingSize;
  public styleOptions = OmpPillButtonStyleOptions;
  public wideContentWidth = OmpCrossSellWideContentWidth;

  @Input() contentWidth: number;

  get maxDesktopColumns(): number {
    let columns = OmpCrossSellNarrowMaxColumns;
    if (Number(this.contentWidth) >= OmpCrossSellWideContentWidth) {
      columns = OmpCrossSellMaxColumns;
    }
    return columns;
  }

  // A saved 4 outlives a later narrower Maximum Content Width; the portal clamps it the same
  // way, so the slider shows what customers actually see.
  get desktopColumns(): number {
    let columns = this.maxDesktopColumns;
    if (this.data && this.data.columns_desktop) {
      columns = Math.min(this.data.columns_desktop, this.maxDesktopColumns);
    }
    return columns;
  }

  get canUseWideColumns(): boolean {
    return this.maxDesktopColumns === OmpCrossSellMaxColumns;
  }
}
